export { default as getFilteredComponents } from './getFilteredComponents';
